module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
  var labelSize = 'label-65';

  if (factoryKey === 'control_set_filter') {
    labelSize = 'label-80';
  }
  

    ; __append("\r\n\r\n\r\n<div class=\"row\"> \r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel ")
    ; __append(escapeFn( labelSize ))
    ; __append("\">Field</label> \r\n        <div>\r\n            <select name=\"field\" id=\"field\">\r\n                <option value=\"none\">None</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n\r\n")
  }
  return __output;

}